import gql from 'graphql-tag';

const userIdAndDisplay = gql`
  fragment UserIdAndDisplayFields on User {
    userId
    displayName
    avatarUrl
  }
`;

const user = gql`
  fragment UserFields on User {
    email
    userName
    userId
    displayName
    avatarUrl
    isAdmin
  }
`;

// TODO: once Posts and Comments share an interface for page fields, combine these.
const postPagination = gql`
  fragment PostPaginationFields on Posts {
    startId
    endId
    hasAnyNext
  }
`;

const commentPagination = gql`
  fragment CommentPaginationFields on Comments {
    startId
    endId
    hasAnyNext
  }
`;

const post = gql`
  fragment PostFields on Post {
    id
    message
    created
    commentCount
    isPinned
    likeCount
    likedByMe
    byMe
    imageUrl
    likedBy(posts: $posts) {
      ...UserIdAndDisplayFields
    }
    author {
      ...UserIdAndDisplayFields
    }
  }
  ${userIdAndDisplay}
`;

const comment = gql`
  fragment CommentFields on Comment {
    id
    postId
    comment
    created
    likedByMe
    likeCount
    byMe
    author {
      ...UserIdAndDisplayFields
    }
  }
  ${userIdAndDisplay}
`;

const postWithComments = gql`
  fragment PostWithComments on Post {
    ...PostFields
    comments(comments: $comments) {
      comments {
        ...CommentFields
      }
      ...CommentPaginationFields
    }
  }
  ${post}
  ${comment}
  ${commentPagination}
`;

const chatMessage = gql`
  fragment ChatMessageFields on ChatMessage {
    id
    room
    message
    created
    author {
      ...UserIdAndDisplayFields
    }
  }
  ${userIdAndDisplay}
`;

const communityMessage = gql`
  fragment CommunityMessageFields on CommunityMessage {
    id
    message
    start
    end
    durationSec
  }
`;

const game = gql`
  fragment Game on Game {
    id
    name
    displayName
    description
    isMobileFriendly
  }
`;

const tournament = gql`
  fragment Tournament on Tournament {
      id
      name
      startTime
      endTime
      status
      startChips
      description
      game { ...Game }
      category { id title }
      created
      terms { id title }
      serverTime
  }
  ${game}
`;

const tournamentLeaderboard = gql`
  fragment TournamentLeaderboard on Tournament {
    leaderBoard {
      rankings {
        player {
          displayName
          userId
          avatarUrl
        }
        score
        rank
      }
    }
  }
`;

const fragments = {
  user,
  userIdAndDisplay,
  postPagination,
  commentPagination,
  post,
  postWithComments,
  comment,
  chatMessage,
  communityMessage,
  game,
  tournament,
  tournamentLeaderboard
};

export default fragments;



// WEBPACK FOOTER //
// ./src/utils/graphql/fragments.js